// src/container/home/Home.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import Header from './header'; // Certifique-se de usar o caminho correto para o Header
import Carrossel from './carrossel';
import VLibras from 'react-vlibras';
import Introduction from './introduction';
import ClinicaCard from './clinic';
import Contadores from './contadores';
import CarrosselConvenios from './carrosselConvenios';
import CarrsseCanoas from './CarroselCanoasPrev';
import FaqMediacao from './faq';

const Home = () => {
  return (
    <div>
      <Header />
      <Carrossel />
      <VLibras />
      <Introduction />
      <Contadores />
      <ClinicaCard />
      <CarrosselConvenios />
      <CarrsseCanoas />
      <FaqMediacao />
    </div>
  );
};

export default Home;
